import Modal, { ModalRef } from '@ui-components-3/ui/lib/components/Modal'
import ExternalLink from 'components/common/ExternalLink'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { TERMS_CONDITIONS_LINK } from 'util/constants'

export type VisitWarningModalProps = {
  onDismiss: () => void
}

const VisitWarningModal = forwardRef<ModalRef, VisitWarningModalProps>(({ onDismiss, ...props }, ref) => {
  const { t } = useTranslation()

  return (
    <Modal
      {...props}
      ref={ref}
      className="w-[564px] backdrop:backdrop-brightness-50"
      label={t('visitWarning.title')}
      footer={() => (
        <button type="button" className="btn btn-neutral" onClick={onDismiss}>
          {t('visitWarning.ok')}
        </button>
      )}
    >
      <p className="typography-body-l font-medium text-neutral-800">
        {t('visitWarning.message')}{' '}
        <ExternalLink href={TERMS_CONDITIONS_LINK} className="text-primary-500 underline">
          {t('visitWarning.termsAndConditions')}{' '}
        </ExternalLink>
        {t('visitWarning.moreInfo')}
      </p>
    </Modal>
  )
})

export default VisitWarningModal
